import { Modal, message } from 'antd';
import { useEffect, useState } from 'react';
import { api } from '../config/api';
import './AssignSpotsPage.css';
import SearchFilterClass from './SearchFilter';

const AssignSpotsPage = () => {
  const [classes, setClasses] = useState([]);
  const [filteredClasses, setFilteredClasses] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch(api.assign)
      .then(res => res.json())
      .then(data => {
        setClasses(data);
        setFilteredClasses(data);
        setIsLoading(false);
      })
      .catch(err => {
        console.error('Failed to fetch classes:', err);
        setIsLoading(false);
      });
  }, []);

  const normalizeText = (str = '') =>
    str
      .replace(/\s+/g, ' ') // 多空格变一空格
      .replace(/｜/g, '|') // 全角竖线变半角
      .trim()
      .toLowerCase();

  const formatDateOnly = (dateStr) => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    if (isNaN(d)) return dateStr;
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const handleSearchFilter = ({ name, class_date, studio, instructor }) => {
    const normalizedName = normalizeText(name);
    const formattedClassDate = class_date ? formatDateOnly(class_date) : '';

    const filtered = classes.filter(cls => {
      const clsDateFormatted = formatDateOnly(cls.class_date);

      return (
        normalizeText(cls.name).includes(normalizedName) &&
        (!formattedClassDate || clsDateFormatted === formattedClassDate) &&
        (!studio || cls.studio === studio) &&
        (!instructor || cls.instructor?.name === instructor)
      );
    });

    setFilteredClasses(filtered);
  };

  const handleToggleCancelled = (cls) => {
    const isCancelled = cls.is_cancelled !== 0;

    Modal.confirm({
      title: isCancelled ? '确定要启用该课程吗？' : '确定要取消该课程吗？',
      okText: '确定',
      cancelText: '取消',
      onOk() {
        console.warn(cls);
        fetch(`${api.assign}/${cls.serial_num}/cancel_toggle`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ is_cancelled: isCancelled ? 0 : 1 }),
        })
          .then(res => {
            if (!res.ok) throw new Error('Failed to update cancel status');
            setClasses(prev =>
              prev.map(c =>
                c.serial_num === cls.serial_num ? { ...c, is_cancelled: isCancelled ? 0 : 1 } : c
              )
            );
            setFilteredClasses(prev =>
              prev.map(c =>
                c.serial_num === cls.serial_num ? { ...c, is_cancelled: isCancelled ? 0 : 1 } : c
              )
            );
            message.success('状态更新成功');
          })
          .catch(err => {
            console.error('Failed to toggle cancel status:', err);
            message.error('状态更新失败');
          });
      },
    });
  };

  return (
    <div className="assign-spots-page">
      <h2>课程预约信息</h2>

      {isLoading ? (
        <div className="loading-spinner-wrapper">
          <div className="spinner"></div>
          <div className="loading-text">正在加载课程数据...</div>
        </div>
      ) : (
        <>
          <SearchFilterClass
            onSearchFilter={handleSearchFilter}
            instructors={[...new Set(classes.map(c => c.instructor?.name))]}
            studios={[...new Set(classes.map(c => c.studio))]}
            classDates={[...new Set(classes.map(c => formatDateOnly(c.class_date)))]}
          />
          <div className="table-wrapper">
            <table className="class-table">
              <thead>
                <tr>
                  <th>课程ID</th>
                  <th>课程名称</th>
                  <th>日期</th>
                  <th>时间</th>
                  <th>门店</th>
                  <th>讲师</th>
                  <th>最大人数</th>
                  <th>小程序预约</th>
                  <th>ClassPass 预约</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                {filteredClasses.map(cls => {
                  const isCancelled = cls.is_cancelled !== 0;

                  return (
                    <tr key={cls.serial_num} className={isCancelled ? 'cancelled-row' : ''}>
                      <td>{cls.id}</td>
                      <td>
                        {cls.name}
                        {isCancelled && <span className="cancelled-tag">（已取消）</span>}
                      </td>
                      <td>{formatDateOnly(cls.class_date)}</td>
                      <td>
                        {new Date(cls.start_datetime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })} -{' '}
                        {new Date(cls.end_datetime).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                      </td>
                      <td>{cls.studio}</td>
                      <td>{cls.instructor?.name || '—'}</td>
                      <td>{cls.max_spots}</td>
                      <td>
                        <div className="progress-block">
                          {cls.miniapp ? (() => {
                            const [booked, total] = cls.miniapp.split('/').map(Number);
                            const percent = total ? (booked / total) * 100 : 0;
                            return (
                              <div className="progress-box">
                                <div className="progress-outer">
                                  <div className="progress-inner" style={{ width: `${percent}%` }} />
                                </div>
                                <div className="progress-text">{cls.miniapp}</div>
                              </div>
                            );
                          })() : <div className="progress-text">—</div>}
                        </div>
                      </td>
                      <td>
                        <div className="progress-block">
                          {cls.cp ? (() => {
                            const [booked, total] = cls.cp.split('/').map(Number);
                            const percent = total ? (booked / total) * 100 : 0;
                            return (
                              <div className="progress-box">
                                <div className="progress-outer">
                                  <div className="progress-inner" style={{ width: `${percent}%` }} />
                                </div>
                                <div className="progress-text">{cls.cp}</div>
                              </div>
                            );
                          })() : <div className="progress-text">—</div>}
                        </div>
                      </td>
                      <td>
                        <button
                          onClick={() => handleToggleCancelled(cls)}
                          className={isCancelled ? 'toggle-btn-enable' : 'toggle-btn-cancel'}
                        >
                          {isCancelled ? '启用' : '取消'}
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </>
      )}
    </div>
  );
};

export default AssignSpotsPage;
